import React from 'react';
import Select, { Props } from 'react-select';
import { customStyles } from './Select.style';

export const CustomSelect: React.FC<Props> = (props): JSX.Element => {
    return <Select {...props} getOptionLabel={(option: any) => `${option.label}`} isSearchable={false} styles={customStyles} />;
};
